module.exports = __webpack_public_path__ + "static/media/VaderPay.83bafd76.svg";